<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-row class="justify-content-center pl-1 pr-1">
      <b-col md="8" class="mt-3" style="display: flex;flex-flow: column;">
          <b-card no-body style="flex: 1 1 auto; display: flex;flex-flow: column; margin-bottom: 0px">
            <b-tabs pills card>
              <b-tab title="Vorgefertigte Tour" active>
                <b-row>
                  <b-col>
                    <b-row class="mt-1">
                      <b-col md="3" class="my-auto">
                        <span>Tourname</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-input class="form-control text-black"
                                      v-model="tour.name"
                                      :disabled="!editMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col md="3">
                        <span>Hinweis</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-textarea
                            class="text-black"
                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                            :disabled="!editMode"
                            type="text"
                            v-model="tour.description"
                            :placeholder="tour.description"
                            wrap="hard"
                            rows="4"
                            :max-rows="maxrows"
                        >
                        </b-form-textarea>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col>
                    <b-row class="mt-1">
                      <b-col md="3" class="my-auto">
                        <span>Leistungsgrp.</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-input class="form-control text-black"
                                      v-model="formateLegr"
                                      disabled></b-form-input>
                      </b-col>
                      <b-col md="2" class="my-auto pl-0"  v-if="editMode">
                        <b-button variant="success"  class="btn-pill font-sm" @click="isPlanningLegr = false; $refs.select_legr.showDialog(legrs, true)">
                          Ändern
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1" v-if="tour.legr">
                      <b-col md="3" class="my-auto">
                        <span>Leistungsart</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-input class="form-control text-black"
                                      v-model="formatLear"
                                      disabled></b-form-input>
                      </b-col>
                      <b-col md="2" class="my-auto pl-0"  v-if="editMode">
                        <b-button variant="success"  class="btn-pill font-sm" @click="$refs.select_lear.showDialog(possibleLears, true)">
                          Ändern
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col md="3" class="my-auto">
                        <span>Tourtyp</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-select :options="singleStammSelects"
                                       v-model="tour.is_single_stamm"
                                       class="text-black"
                                       :disabled="!editMode"></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1" v-if="tour.is_single_stamm">
                      <b-col md="3" class="my-auto">
                        <span>Stammauf.</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-input class="form-control text-black"
                                      v-model="formateStandartTask"
                                      disabled></b-form-input>
                      </b-col>
                      <b-col md="2" class="my-auto pl-0"  v-if="editMode">
                        <b-button variant="success"  class="btn-pill font-sm" @click="selectForTaskStandardTask = false; $refs.select_aufisn.showDialog(augrs, aufisns, true)">
                          Ändern
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1" v-if="tour.is_single_stamm">
                      <b-col md="3" class="my-auto">
                        <span>Automatisch abhaken ?</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-checkbox switch v-model="tour.use_automatic" :disabled="!editMode"></b-form-checkbox>
                      </b-col>
                    </b-row>

                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Erweiterte Einstellungen">
                <b-row>
                <b-col>
                  <b-row class="mt-1">
                    <b-col md="4" class="my-auto">
                      <span>Aufgaben aus Tour ?</span>
                    </b-col>
                    <b-col class="my-auto">
                      <b-form-checkbox switch v-model="tour.can_create_tasks" :disabled="!editMode"></b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1" v-if="tour.can_create_tasks">
                    <b-col md="4" class="my-auto">
                      <span>Aufgabenname</span>
                    </b-col>
                    <b-col class="my-auto">
                      <b-form-input class="form-control text-black"
                                    v-model="tour.task_default_name"
                                    :disabled="!editMode"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1" v-if="tour.can_create_tasks">
                    <b-col md="4" class="my-auto">
                      <span>Stammauf.</span>
                    </b-col>
                    <b-col class="my-auto">
                      <b-form-input class="form-control text-black"
                                    v-model="formateTaskStandartTask"
                                    disabled></b-form-input>
                    </b-col>
                    <b-col md="2" class="my-auto pl-0"  v-if="editMode">
                      <b-button variant="success"  class="btn-pill font-sm" @click="selectForTaskStandardTask = true; $refs.select_aufisn.showDialog(augrs, aufisns, false)">
                        Ändern
                      </b-button>
                    </b-col>
                  </b-row>

                </b-col>
                  <b-col>
                    <b-row class="mt-1">
                      <b-col md="4" class="my-auto">
                        <span>Als allgemeine Tour aufführen?</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-checkbox switch v-model="tour.is_general_tour" :disabled="!editMode"></b-form-checkbox>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col md="4" class="my-auto">
                        <span>Reihenfolge vorgeben ?</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-checkbox switch v-model="tour.use_order" :disabled="!editMode"></b-form-checkbox>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1" v-if="hasTraceTours">
                      <b-col md="4" class="my-auto">
                        <span>Tourbearbeitung tracken ?</span>
                      </b-col>
                      <b-col class="my-auto">
                        <b-form-checkbox switch v-model="tour.trace_tour" :disabled="!editMode"></b-form-checkbox>
                      </b-col>
                    </b-row>
                  </b-col>
    </b-row>
              </b-tab>
            </b-tabs>
          </b-card>
      </b-col>
      <b-col md="4" class="mt-3" style="display: flex;flex-flow: column;">
        <b-card>
          <b-row style="gap: 10px">
            <b-button v-if="editMode" :disabled="!canContinue" variant="success" class="btn-pill font-lg" v-on:click="toggleEditMode(true)">
              {{tourId === 'new' ? 'Erstellen' : 'Speichern'}}
            </b-button>
            <b-button v-if="editMode && tourId !== 'new'" variant="warning" class="btn-pill font-lg" v-on:click="toggleEditMode(false)">
              Abbruch
            </b-button>
            <b-button v-if="!editMode" variant="success" class="btn-pill font-lg" v-on:click="$refs.plan_tour.onShow(tour)">
              Beplanen
            </b-button>
            <b-button v-if="!editMode" variant="success" class="btn-pill font-lg" v-on:click="toggleEditMode(undefined)">
              Ändern
            </b-button>
            <b-button v-if="!editMode && tourId !== 'new'" variant="success" class="btn-pill font-lg" v-on:click="$router.push('/aufgaben/predefined_tour_execution/' + tourId)">
              Ausführungen
            </b-button>
            <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
              Zurück
            </b-button>
          </b-row>
        </b-card>
        <b-card class="mb-0 flex-body" style="flex: 1 1 auto; display: flex;flex-flow: column;">
          <div slot="header"
               style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
            <b-row style="margin-left: 0px; margin-right: 0px">
              <div>
                <strong>Fahrzeuge</strong>
              </div>
              <b-col></b-col>
              <b-button v-if="editMode" variant="success" class="btn-pill font-sm" v-on:click="showFahrModal" style="margin-top: -8px;margin-bottom: -8px;">
                Ändern
              </b-button>
            </b-row>
          </div>
          <b-form-tags
              v-model="formateFahrs"
              tag-variant="secondary"
              tag-pills
              size="lg"
              disabled
              placeholder=""
              wrap="hard"
              max-rows="2"
          ></b-form-tags>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center pl-1 pr-1">
      <b-col md="8" class="mt-3">
        <b-card-group>
          <b-card class="no-margin">
            <div slot="header"
                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
              <b-row style="margin-left: 0px; margin-right: 0px">
                <div>
                  <strong>Aufgabenkarte</strong>
                </div>
                <b-col></b-col>
                <b-button v-if="editMode && isOrderMode && tour.use_order && calculateOptimal" :disabled="lat === 0.0" variant="success" class="btn-pill font-sm" v-on:click="calculateOptimalOrder" style="margin-top: -8px;margin-bottom: -8px; margin-right: 12px">
                  Berechnen
                </b-button>
                <b-button v-if="editMode && isOrderMode && tour.use_order && calculateOptimal" variant="warning" class="btn-pill font-sm" v-on:click="toggleCalculateOptimal" style="margin-top: -8px;margin-bottom: -8px; margin-right: 12px">
                  Abbrechen
                </b-button>
                <b-button v-if="editMode && isOrderMode && tour.use_order && !calculateOptimal" variant="success" class="btn-pill font-sm" v-on:click="toggleCalculateOptimal" style="margin-top: -8px;margin-bottom: -8px; margin-right: 12px">
                  Optimale Reihenfolge
                </b-button>
      <b-button v-if="editMode && isOrderMode && tour.use_order && !calculateOptimal" variant="success" class="btn-pill font-sm" v-on:click="resetOrdering" style="margin-top: -8px;margin-bottom: -8px; margin-right: 12px">
        Reihenfolge zurücksetzen
      </b-button>
              </b-row>
            </div>
            <b-col style="height: 55vh; padding: 0; margin-bottom: 0" id="map_container"
                   ref="map_container">
            </b-col>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col md="4" class="mt-3">
        <b-card class="no-margin">
          <div slot="header"
               style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
            <b-row style="margin-left: 0px; margin-right: 0px">
              <div>
                <strong>Teilaufgaben</strong>
              </div>
              <b-col></b-col>
              <b-button v-if="editMode && isOrderMode" variant="success" class="btn-pill font-sm" v-on:click="toggleOrderMode" style="margin-top: -8px;margin-bottom: -8px; margin-right: 12px">
                Teilaufgaben ändern
              </b-button>
              <b-button v-if="editMode && !isOrderMode && tour.use_order" variant="success" class="btn-pill font-sm" v-on:click="toggleOrderMode" style="margin-top: -8px;margin-bottom: -8px; margin-right: 12px">
                Reihenfolge ändern
              </b-button>
              <b-button v-if="editMode && !isOrderMode" variant="success" class="btn-pill font-sm" v-on:click="showSelectAufisn = true" style="margin-top: -8px;margin-bottom: -8px;">
                Hinzufügen
              </b-button>
            </b-row>
          </div>
          <b-col style="padding: 0px">
            <b-table sticky-header striped hover
                     :key="componentKey"
                     ref="tour_objects_table"
                     :items="tour_tasks"
                     :fields="fields"
                     selectable
                     select-mode="single"
                     @row-selected="onRowSelected"
                     selectedVariant="primary"
                     style="max-height: 55vh; min-height: 55vh; margin-bottom: 0px"
                     v-if="!isOrderMode && editMode"
            >
              <template v-slot:cell(name)="data">
                <b-form-input v-model="tour_tasks[data.index]['name']"/>
              </template>
              <template v-slot:cell(lat)="data">
                {{formateCoordinates(data.value)}}
              </template>
              <template v-slot:cell(controls)="data">
                <duplicate-icon
                    title=""
                    v-tooltip="'Duplizieren'"
                    class="icon-1_5x" style="color: #016d03; cursor: pointer" :size="72" @click.stop="onDuplicate(data.item)"></duplicate-icon>
                <delete-icon
                    title=""
                    v-tooltip="'Löschen'"
                    class="icon-1_5x" style="color: #b60110; cursor: pointer" :size="72" @click.stop="onDelete(data.item.id)"></delete-icon>
             </template>
            </b-table>
            <b-table sticky-header striped hover
                     :items="tour_tasks"
                     :fields="fields_order"
                     style="max-height: 55vh; min-height: 55vh; margin-bottom: 0px"
                     v-else
            >
              <template v-slot:cell(name)="data">
                <b-form-input v-model="tour_tasks[data.index]['name']" :disabled="!editMode"/>
              </template>
              <template v-slot:cell(lat)="data">
                {{formateCoordinates(data.value)}}
              </template>
            </b-table>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <b-modal size="lg" v-model="showSelectAufisn" centered title="Stammauftrag wählen"
    >
      <b-row>
        <b-col style="padding-left: 20px; padding-right: 20px">
          <p><b>Gruppe wählen</b></p>
        </b-col>
        <b-col style="padding-left: 20px; padding-right: 20px">
          <p><b>Auftrag wählen</b></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="height: 55vh; overflow: auto">
          <b-table thead-class="display_none" striped hover selectable :items="augrs" :fields="group_fields"
                   select-mode="single"
                   selectedVariant="primary"
                   @row-selected="rowSelectedGroup"
                   ref="group_table"
          >

          </b-table>
        </b-col>
        <b-col style="height: 55vh; overflow: auto">
          <b-table thead-class="display_none" striped hover :items="objects" :fields="object_fields" selectable
                   select-mode="range"
                   selectedVariant="primary"
                   @row-selected="rowSelectedObject"
                   ref="object_table"
          >
          </b-table>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showSelectAufisn = false">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="!canContinueAufisn" variant="success" @click="onAufisnSelected">
          Annehmen
        </b-button>
      </template>
    </b-modal>
    <b-modal size="md" v-model="showSelectFahrs" centered title="Fahrzeuge wählen"
    >
      <b-row>
        <b-col style="height: 55vh; overflow: auto">
          <b-table thead-class="display_none" striped hover selectable :items="fahrs" :fields="fahr_fields"
                   select-mode="multi"
                   selectedVariant="primary"
                   ref="fahr_table"
          >
          </b-table>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showSelectFahrs = false">
          Abbrechen
        </b-button>
        <b-button size="md" variant="success" @click="onFahrsSelected">
          Annehmen
        </b-button>
      </template>
    </b-modal>
    <select-legr-dialog ref="select_legr" @legr-selected="onLegrChanged"></select-legr-dialog>
    <select-lear-dialog ref="select_lear" @lear-selected="onLearChanged"></select-lear-dialog>
    <plan-tour-dialog ref="plan_tour" :legrs="legrs"
                      @select-legr="isPlanningLegr = true; $refs.select_legr.showDialog(legrs)"
                      @select-planning="(users) => {$refs.select_plannings.showDialog(users)}"
                      @change-planning="(currentPlanning) => {$refs.change_todo.showDialog(currentPlanning)}"
                      :bauhof-structure="bauhofStructure"
                      :groups="augrs"
                      :objects-map="aufisns"
                      :fahrs="fahrs"
                      @plan-tour="onPlanTour"
    ></plan-tour-dialog>
    <select-planning-dialog ref="select_plannings" @planning-selected="(plannings) => {$refs.plan_tour.onNewPlanning(plannings)}"></select-planning-dialog>
    <change-todo-dialog ref="change_todo" @change-todo="(todo) => {$refs.plan_tour.onChangeTodo(todo)}"></change-todo-dialog>
    <select-aufisn-dialog ref="select_aufisn" @aufisn-selected="onAufisnChanged"></select-aufisn-dialog>
    <b-modal size="md" v-model="showHint" centered title="Optimale Reihenfolge berechnen"
    >
      <b-row><b-col>
        <p>Um die Optimale Reihenfolge berechnen zu können, müssen Sie zunächst einen <b>Startpunkt</b> festlegen, klicken Sie dazu auf die Karte.<br>Danach wird der <b>"Berechnen"</b> Knopf aktiv.</p>
      </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showHint = false">
          Verstanden
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from 'luxon'
import {
  arrayBufferToBase64,
  decryptAES,
  decryptFile,
  decryptMessages,
  decryptTodos,
  encryptAES,
  encryptFile,
  encryptServerTodos
} from "@/shared/crypto";
import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
import AccountBox from 'vue-material-design-icons/AccountBox.vue';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import StylesControl from 'mapbox-gl-controls/lib/styles';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import {arrayContains, Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import {styles} from '@/shared/draw_style';

import FinishIcon from 'vue-material-design-icons/CheckCircle.vue';

import EditIcon from 'vue-material-design-icons/PencilCircle.vue';

import { draggabletable } from "@/shared/v-dragable";
import {v4} from "uuid";


import DeleteIcon from 'vue-material-design-icons/Delete.vue';
import DuplicateIcon from 'vue-material-design-icons/ContentDuplicate.vue';
import SelectLegrDialog from "@/views/aufgaben_verwaltung/SelectLegrDialog.vue";
import SelectLearDialog from "@/views/aufgaben_verwaltung/SelectLearDialog.vue";
import PlanTourDialog from "@/views/predefined_tours/PlanTourDialog.vue";
import SelectPlanningDialog from "@/views/aufgaben_verwaltung/SelectPlanningDialog.vue";
import ChangeTodoDialog from "@/views/aufgaben_verwaltung/ChangeTodoDialog.vue";
import SelectAufisnDialog from "@/views/aufgaben_verwaltung/SelectAufisnDialog.vue";

export default {
  name: "PredefinedTour",
  components: {
    AccountMultiplePlusIcon,
    AccountBox,
    BookOpenPageVariantIcon,
    CheckBoldIcon,
    FinishIcon,
    DeleteIcon,
    EditIcon,
    DuplicateIcon,
    SelectLegrDialog,
    PlanTourDialog,
    SelectPlanningDialog,
    ChangeTodoDialog,
    SelectAufisnDialog,
    SelectLearDialog
  },
  computed: {
    hasTraceTours() {
      let suiteModules = sessionStorage.getItem("suite_modules");
      if (suiteModules !== null && suiteModules !== '') {
        suiteModules = JSON.parse(suiteModules);
        if (arrayContains(suiteModules, 30)) {
          return true
        }
      }
      return false;
    },
    componentKey() {
      return this.editMode ? 'edit' : 'view';
    },
    canContinue() {
      return true
    },
    canContinueAufisn() {
      return this.selected.length > 0;
    },
    formateLegr() {
      for (let i = 0; i < this.legrs.length; i++) {
        if (this.legrs[i].id === this.tour.legr) {
          return this.legrs[i].name;
        }
      }
      return "Bitte auswählen";
    },
    formatLear() {
      for (let i = 0; i < this.lears.length; i++) {
        if (this.lears[i].id === this.tour.lear) {
          return this.lears[i].name;
        }
      }
      return "Bitte auswählen";
    },
    possibleLears() {
      let legr = null;
      for (let i = 0; i < this.legrs.length; i++) {
        if (this.legrs[i].id === this.tour.legr) {
          legr = this.legrs[i];
          break;
        }
      }
      let res = [];
      if (legr) {
        console.log(legr)
        for (let i = 0; i < this.lears.length; i++) {
          console.log(this.lears[i])
          if (this.lears[i].legr === legr.name) {
            res.push(this.lears[i]);
          }
        }
      }
      return res;
    },
    formateStandartTask() {
      for (const valueKey in this.aufisns) {
        if (this.aufisns[valueKey].length) {
          for (let i = 0; i < this.aufisns[valueKey].length; i++) {
            if (this.aufisns[valueKey][i].id === this.tour.standard_task) {
              return this.aufisns[valueKey][i].object;
            }
          }
        }
      }
      return "Bitte auswählen";
    },
    formateTaskStandartTask() {
      for (const valueKey in this.aufisns) {
        if (this.aufisns[valueKey].length) {
          for (let i = 0; i < this.aufisns[valueKey].length; i++) {
            if (this.aufisns[valueKey][i].id === this.tour.task_standard_task) {
              return this.aufisns[valueKey][i].object;
            }
          }
        }
      }
      return "Bitte auswählen";
    },
    formateFahrs: {
      get(){
        let res = [];
        if(this.tour.vehicles && this.tour.vehicles.length) {
          for (let i = 0; i < this.tour.vehicles.length; i++) {
            for (let j = 0; j < this.fahrs.length; j++) {
              if (this.fahrs[j].access === this.tour.vehicles[i]) {
                res.push(this.fahrs[j].name);
                break;
              }
            }
          }
        }
        return res;
      },
      set(newVal){
        let res = [];
        if(this.tour.vehicles && this.tour.vehicles.length) {
          for (let i = 0; i < this.tour.vehicles.length; i++) {
            for (let j = 0; j < this.fahrs.length; j++) {
              if (this.fahrs[j].access === this.tour.vehicles[i]) {
                res.push(this.fahrs[j].name);
                break;
              }
            }
          }
        }
        return res;
      }
    },
  },
  data: () => {
    return {
      sortableOptions: {
        chosenClass: 'is-selected',
        handle: '.grab-handle',
        // Element is chosen
        // Called when dragging element changes position
        onChange: (evt) => {
          console.log(evt)
          evt.clone.childNodes[1].innerHTML = "Test";
        }
      },
      loader: undefined,
      maxrows: 40,
      editMode: false,
      geoRefPerimeter: "",
      tourId: "",
      tour: {},
      tour_tasks: [],
      legrs: [],
      lears: [],
      augrs: [],
      aufisns: {},
      coords: [],
      fields: [
          //{key: "s_grab", label: ''},
        {key: "name", label: "Name"},
        {key: "task_id", label: "Objekt", formatter: "formatObject"},
        {key: "lat", label: "Koordinaten"}, {key: "controls", label: ''}],
      fields_order: [
        {key: "name", label: "Name"},
        {key: "task_id", label: "Objekt", formatter: "formatObject"},
        {key: "lat", label: "Koordinaten"}],
      currentObject: null,
      isInitial: false,

      showSelectAufisn: false,
      group_fields: [{key: "name", label: 'Gruppe wählen'}],
      object_fields: [{key: "object", label: 'Objekt wählen'}],
      fahr_fields: [{key: "name", label: 'Fahrzeugname'}],
      selected: [],
      currentGroup: {},
      objects: undefined,
      isOrderMode: false,
      calculateOptimal: false,
      lat: 0.0,
      lon: 0.0,
      nextOrder: 0,
      isPlanningLegr: false,
      bauhofStructure: [],
      showSelectFahrs: false,
      fahrs: [],
      selectForTaskStandardTask: false,
      singleStammSelects: [{text: "Erfassen auf Teilaufgaben", value: false}, {text: "Erfassen auf Stammauftrag", value: true}],
      showHint: false,
      locations: [],
    }
  },
  created() {
    this.showLoader();
    this.tourId = this.$route.params.id;
    this.startPoint = null;
    if (this.tourId === 'new') {
      this.editMode = true;
    }
    this.$http.get(
        Server_URL + '/auftragsbuch/data/predefined_tour/' + this.tourId
    ).then(this.responseOkFetch, this.responseError)
  },
  methods: {
    toggleCalculateOptimal() {
      this.lat = 0.0;
      this.lon = 0.0;
      if (this.calculateOptimal && this.startPoint) {
        this.startPoint.remove();
        this.startPoint = null;
      } else if (!this.calculateOptimal) {
        this.showHint = true;
      }
      this.calculateOptimal = !this.calculateOptimal;
    },
    onMapClick(e) {
      if (!this.calculateOptimal) {return}
      this.lat = e.lngLat.lat;
      this.lon = e.lngLat.lng;

      if (this.startPoint === null) {
        let el = document.createElement('div');
        el.className = 'start-marker';
        el.innerHTML = '<span><b>S</b></span>';
        this.startPoint = new mapboxgl.Marker({
          element: el,
          anchor: 'bottom',
          offset: [0, -10]
        })
            .setLngLat([this.lon, this.lat])
            .addTo(this.map);
      } else {
        this.startPoint.setLngLat([this.lon, this.lat])
      }
    },
    calculateOptimalOrder() {
      this.showLoader();
      this.locations = [];
      this.locations.push({
        "lat": this.lat,
        "lon": this.lon,
        "type": "break",
        "task_id": null,
      });
      for (let i = 0; i < this.tour_tasks.length; i++) {
        let cur = this.tour_tasks[i];
        if (cur.lat !== 0.0 && cur.lon !== 0.0) {
          this.locations.push({
            "lat": cur.lat,
            "lon": cur.lon,
            "type": "break",
            "task_id": cur.id,
          });
        }
      }
      this.locations.push({
        "lat": this.lat,
        "lon": this.lon,
        "type": "break",
        "task_id": null,
      });
      let req = {
        "format": "osm",
        "costing": "auto",
        "directions_type": "none",
        "costing_options": {
          "auto": {
            "width": 1,
            "height": 1,
            "use_living_streets": 1.0,
            "use_tracks": 1,
            "private_access_penalty": 450,
            "ignore_restrictions": true,
            "shortest": false,
            "ignore_access": false,
            "service_penalty": 15,
            "exclude_unpaved": 0,
            "gate_penalty": 300,
            "gate_cost": 30
          }
        },
        "locations": this.locations
      }
      let headers = {
        'Content-Type': 'application/json;charset=utf-8'
      };
      headers['API-Key'] = "KQY4yYK9XdClJTS4Cr3BFRIkkIHix7Bj";
      this.$http.post(
          "https://test-bisoffice.de/valhalla/optimized_route",
          req, {headers}
      ).then(this.onOrderCalculated, this.responseError)
    },
    onOrderCalculated(response) {
      this.hideLoader();
      if (response.status === 200) {
        let resLocations = response.body.trip.locations;
        for (let i = 0; i < this.tour_tasks.length; i++) {
          this.tour_tasks[i].order = -1;
        }
        for (let i = 0; i < resLocations.length; i++) {
          if (i !== 0 && i !== resLocations.length -1) {
            let loc = this.locations[resLocations[i].original_index];
            for (let j = 0; j < this.tour_tasks.length; j++) {
              if (this.tour_tasks[j].id === loc.task_id) {
                this.tour_tasks[j].order = i - 1;
                break;
              }
            }
          }
        }
        this.showOrderMode(true);
        this.toggleCalculateOptimal();
      } else {
        window.location = Redirect_500;
      }
    },
    resetOrdering() {
      for (let i = 0; i < this.tour_tasks.length; i++) {
        this.tour_tasks[i].order = -1;
      }
      this.showOrderMode();
    },
    showFahrModal() {
      this.showSelectFahrs = true;
      this.$nextTick(() => {
        this.$refs.fahr_table.clearSelected();
        for (let i = 0; i < this.fahrs.length; i++) {
          for (let j = 0; j < this.tour.vehicles.length; j++) {
            if (this.fahrs[i].access === this.tour.vehicles[j]) {
              this.$refs.fahr_table.selectRow(i);
              break;
            }
          }
        }
      });
    },
    onPlanTour(req) {
      this.showLoader();
      encryptAES(sessionStorage.getItem("aes"), req.tour_description).then(res => {
        req.tour_description = res;
        this.$http.post(
            Server_URL + '/auftragsbuch/data/plan_predefined_tour/'+this.tourId,
            req
        ).then(this.onPlanTourResponseOk, this.responseError)
      })
    },
    onAufisnChanged({selected_aufisn}) {
      if (this.selectForTaskStandardTask) {
        this.tour.task_standard_task = selected_aufisn ? selected_aufisn.id : "";
      } else {
        this.tour.standard_task = selected_aufisn ? selected_aufisn.id : "";
      }
    },
    onLegrChanged({selected_legr}) {
      if (!this.isPlanningLegr) {
        if (!selected_legr || this.tour.legr !== selected_legr.id) {
          this.tour.lear = "";
        }
        this.tour.legr = selected_legr ? selected_legr.id : "";
      } else {
        this.$refs.plan_tour.onSetLegr(selected_legr.id)
      }
      this.isPlanningLegr = false;
    },
    onLearChanged({selected_lear}) {
        this.tour.lear = selected_lear ? selected_lear.id : "";
    },
    toggleOrderMode() {
      this.isOrderMode = !this.isOrderMode;
      if (this.isOrderMode) {
        this.map.removeControl(this.draw);
        this.map.off('draw.modechange', this.onModeChange);
        this.map.off('draw.create', this.onFeatureCreate);
        this.map.off('draw.delete', this.onFeatureDelete);
        this.map.off('draw.update', this.onFeatureMove);
        this.showOrderMode(true);
        if (this.calculateOptimal) {
          this.toggleCalculateOptimal();
        }
      } else {
        this.map.addControl(this.draw, 'top-left');
        this.map.on('draw.modechange', this.onModeChange);
        this.map.on('draw.create', this.onFeatureCreate);
        this.map.on('draw.delete', this.onFeatureDelete);
        this.map.on('draw.update', this.onFeatureMove);
        this.$nextTick(() => {
            this.onRowSelected([]);
        })
      }
    },
    showOrderMode(init) {
      this.removeMapSources();
      // order tour_tasks by order and keep the items with order -1 at the end
      this.tour_tasks.sort((a, b) => {
        if (a.order === -1) {
          return 1;
        }
        if (b.order === -1) {
          return -1;
        }
        return a.order - b.order;
      });
      this.tour_tasks = [...this.tour_tasks];
      // normalize the positive orders to 0..n
      this.nextOrder = 0;
      for (let i = 0; i < this.tour_tasks.length; i++) {
        if (this.tour_tasks[i].order !== -1) {
          this.tour_tasks[i].order = this.nextOrder;
          this.nextOrder++;
        }
      }
      let bounds = null;
      for (let i = 0; i < this.tour_tasks.length; i++) {
        let cur = this.tour_tasks[i];
        if (cur.lat !== 0.0 && cur.lon !== 0.0) {
          let el = document.createElement('div');
          el.className = 'order-marker';
          el.innerHTML = '<span><b>' + (cur.order !== -1 && this.tour.use_order ?  ( cur.order+ 1) : '') + '</b></span>';
          el.id = cur.id;
          if (this.isOrderMode) {
            el.addEventListener('click', (e) => {
              let id = e.target.id;
              if (id === "") {
                id = e.target.parentElement.id;
                if (id === "") {
                  id = e.target.parentElement.parentElement.id;
                }
              }
              for (let j = 0; j < this.tour_tasks.length; j++) {
                if (this.tour_tasks[j].id === id) {
                  this.tour_tasks[j].order = this.tour_tasks[j].order === -1 ? this.nextOrder : -1;
                  this.nextOrder++;
                  break;
                }
              }
              this.showOrderMode();
            });
          }
          if (!bounds) {
            bounds = new (mapboxgl.LngLatBounds);
          }
          let coords = [cur.lon, cur.lat];
          let marker = new mapboxgl.Marker({
            element: el,
            anchor: 'bottom',
            offset: [0, -10]
          })
              .setLngLat(coords)
              .addTo(this.map);
          this.markers.push(marker);
          bounds.extend(coords)
        }
      }
      if (init && bounds) {
        setTimeout(() => {
          this.map.fitBounds(bounds, {padding: 100, duration: 500});
        });
      }
    },
    onDuplicate(item) {
      let it = {...item};
      it.id = 'new-' + v4();
      it.lat = 0.0;
      it.lon = 0.0;
      it.order = -1;
      this.tour_tasks.push(it);
      this.$nextTick(() => {
        this.$refs.tour_objects_table.selectRow(this.tour_tasks.length - 1);
      });
    },
    onDelete(id) {
      for (let i = 0; i < this.tour_tasks.length; i++) {
        if (this.tour_tasks[i].id === id) {
          this.tour_tasks.splice(i, 1);
          break;
        }
      }
      if (this.currentObject !== null) {
        this.$refs.tour_objects_table.selectRow();
      } else {
        this.onRowSelected([]);
      }
    },
    formatObject(value) {
      for (const valueKey in this.aufisns) {
        if (this.aufisns[valueKey].length) {
          for (let i = 0; i < this.aufisns[valueKey].length; i++) {
            if (this.aufisns[valueKey][i].id === value) {
              return this.aufisns[valueKey][i].object;
            }
          }
        }
      }
      return "";
    },
    formateCoordinates(coords) {
      if (coords === 0.0) {
        return "Nein"
      } else {
        return "Ja"
      }
    },
    onAufisnSelected() {
      this.showSelectAufisn = false;
      for (let i = 0; i < this.selected.length; i++) {
        this.tour_tasks.push({
          id: 'new-' + v4(),
          task_id: this.selected[i].id,
          aufisn: this.selected[i].aufisn,
          name: this.selected[i].object,
          description: '',
          lat: 0.0,
          lon: 0.0,
          order: -1,
        });
      }
      if (this.selected.length === 1) {
        this.$nextTick(() => {
          this.$refs.tour_objects_table.selectRow(this.tour_tasks.length - 1);
        });
      } else {
        if (this.currentObject !== null) {
          this.$refs.tour_objects_table.selectRow();
        } else {
          this.onRowSelected([]);
        }
      }
    },
    onFahrsSelected() {
      this.tour.vehicles = [];
      for (let i = 0; i < this.fahrs.length; i++) {
        if (this.$refs.fahr_table.isRowSelected(i)) {
          this.tour.vehicles.push(this.fahrs[i].access);
        }
      }
      this.showSelectFahrs = false;
    },
    rowSelectedGroup(items) {
      if (items.length === 0) {
        this.objects = undefined;
        this.selected = [];
        this.currentGroup = {};
      } else {
        this.objects = this.aufisns[items[0].gischl];
        this.currentGroup = items[0];
        if (this.objects.length === 1) {
          this.$nextTick(() => {
            this.$refs.object_table.selectRow(0);
          });
        }
      }
    },
    rowSelectedObject(items) {
      this.selected = items;
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }

    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    toggleEditMode(save) {
      if (save === undefined) {
        this.tourSave = {...this.tour};
        this.torTasksSave = JSON.parse(JSON.stringify(this.tour_tasks));
        this.currentObject = null;
        this.isOrderMode = false;
        this.map.addControl(this.draw, 'top-left');
        this.map.on('draw.modechange', this.onModeChange);
        this.map.on('draw.create', this.onFeatureCreate);
        this.map.on('draw.delete', this.onFeatureDelete);
        this.map.on('draw.update', this.onFeatureMove);
        this.$nextTick(() => {
          this.onRowSelected([]);
        });
      } else if (save === false) {
        this.tour = {...this.tourSave};
        this.tour_tasks = JSON.parse(JSON.stringify(this.torTasksSave));
        this.currentObject = null;
        if (!this.isOrderMode) {
          this.map.removeControl(this.draw);
          this.map.off('draw.modechange', this.onModeChange);
          this.map.off('draw.create', this.onFeatureCreate);
          this.map.off('draw.delete', this.onFeatureDelete);
          this.map.off('draw.update', this.onFeatureMove);
        }
        this.isOrderMode = false;
        this.showOrderMode(true);
      } else {
        this.showLoader();
        if (!this.tour.is_single_stamm) {
          this.tour.use_automatic = false;
        }
        let req = {
          tour: {...this.tour},
          tasks: this.tour_tasks,
        }
        req.tour.vehicles = req.tour.vehicles.join(":::");
        encryptAES(sessionStorage.getItem("aes"), req.tour.description).then(res => {
          req.tour.description = res;
          this.$http.post(
              Server_URL + '/auftragsbuch/data/predefined_tour/'+this.tourId,
              req
          ).then(this.onEditResponseOk, this.responseError)
        })
      }
      this.editMode = !this.editMode;
    },
    async onPlanTourResponseOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        let tourId = response.body.tour_id;
        this.$router.replace("/auftraege/auftrag/"+tourId);

      } else {
        window.location = Redirect_500;
      }
    },
    async onEditResponseOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        let data = response.body.data;
        try {
          if (response.body.data.tour.description !== null && response.body.data.tour.description !== "") {
            response.body.data.tour.description = await decryptAES(sessionStorage.getItem("aes"), response.body.data.tour.description);
          }
        } catch (e) {
        }
        this.tourId = data.tour.id;
        this.tour = data.tour;
        this.tour.vehicles = this.tour.vehicles.split(":::");
        this.tour_tasks = data.tasks;
        this.currentObject = null;
        if (!this.isOrderMode) {
          this.map.removeControl(this.draw);
          this.map.off('draw.modechange', this.onModeChange);
          this.map.off('draw.create', this.onFeatureCreate);
          this.map.off('draw.delete', this.onFeatureDelete);
          this.map.off('draw.update', this.onFeatureMove);
        }
          this.isOrderMode = false;
          this.showOrderMode(true);
        this.hideLoader();
      } else {
        window.location = Redirect_500;
      }
    },
    async responseOkFetch(response) {
      if (response.status === 200) {
        let data = response.body.data;
        try {
          if (response.body.data.tour.description !== null && response.body.data.tour.description !== "") {
            response.body.data.tour.description = await decryptAES(sessionStorage.getItem("aes"), response.body.data.tour.description);
          }
        } catch (e) {
        }
        this.tour = data.tour;
        this.tour.vehicles = this.tour.vehicles.split(":::");
        this.tour_tasks = data.tasks;
        this.legrs = data.legrs;
        this.lears = data.lears;
        this.augrs = data.augrs;
        this.aufisns = data.aufisns;
        this.coords = data.coords;
        this.geoRefPerimeter = data.geo_ref_perimeter;
        this.bauhofStructure = data.kost_migrs;
        this.fahrs = data.fahrs;
        this.hideLoader();
        this.showMap();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    back() {
      window.history.back();
    },
    responseErrorTrap(response) {
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        console.log(response);
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 ) {
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    showMap() {
      setTimeout(() => {
        this.isInitial = true;
        mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
        this.map = new mapboxgl.Map({
          container: 'map_container',
          style: 'mapbox://styles/mapbox/outdoors-v11',
          center: [10.244990, 50.943359],
          zoom: 6,
          minZoom: 5,
          maxZoom: 19,
          maxPitch: 0,
        });
        this.draw = new MapboxDraw({
          displayControlsDefault: false,
          controls: {
            point: true,
            line_string: false,
            polygon: false,
            trash: true,
          },
          styles: styles
        });
        this.map.addControl(new StylesControl({
          styles: [
            {
              label: 'Normal',
              styleName: 'Mapbox Streets',
              styleUrl: 'mapbox://styles/mapbox/outdoors-v11',
            }, {
              label: 'Satellit',
              styleName: 'Satellite',
              styleUrl: 'mapbox://styles/mapbox/satellite-streets-v11',
            },
          ],
          onChange: () => this.map.once("style.load", () => {
            if (this.currentObject) {
              this.onRowSelected([this.currentObject]);
            }
          }),
        }), 'top-left');
        this.map.addControl(new ZoomControl(), 'bottom-right');
        const languageControl = new LanguageControl({
          language: 'de',
        });
        this.map.addControl(languageControl);
        this.geocoder = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
          placeholder: "Suchen",
          zoom: 19,
          language: 'de-DE',
          countries: 'de',
          marker: false,
          flyTo: true,
        });
        this.geocoder.on("result", (res) => {

        });
        this.map.addControl(
            this.geocoder
        );
        this.map.on('click', this.onMapClick);
        this.map.once('load', this.queryPlace)
      });
    },
    queryPlace() {
      setTimeout(() => {
        this.map.resize();
        let hasCoords = false;
        for (let i = 0; i < this.tour_tasks.length; i++) {
          if (this.tour_tasks[i].lat !== 0.0 && this.tour_tasks[i].lon !== 0.0) {
            hasCoords = true;
            break;
          }
        }
        if (this.editMode && !this.isOrderMode) {
          this.$refs.tour_objects_table.selectRow();
        } else {
          setTimeout(() => {
            this.showOrderMode(true);
          });
        }
        if (this.geoRefPerimeter !== "" && !hasCoords) {
          setTimeout(() => {
            let sw = this.geoRefPerimeter.split("||")[0].split(",");
            let ne = this.geoRefPerimeter.split("||")[1].split(",");
            this.map.fitBounds([
              [parseFloat(sw[0]), parseFloat(sw[1])], // southwestern corner of the bounds
              [parseFloat(ne[0]), parseFloat(ne[1])] // northeastern corner of the bounds
            ], {padding: 100, duration: 500});

          });
        };
        if (this.isInitial && this.editMode) {
          this.map.addControl(this.draw, 'top-left');
          this.map.on('draw.modechange', this.onModeChange);
          this.map.on('draw.create', this.onFeatureCreate);
          this.map.on('draw.delete', this.onFeatureDelete);
          this.map.on('draw.update', this.onFeatureMove);
          this.isInitial = false;
        }
      });
    },
    onModeChange(mode) {
      if (mode.mode.startsWith("draw_") && this.draw.getAll().features.length > 1) {
        this.draw.changeMode("simple_select", {
          featureIds: [this.draw.getAll().features[0].id]
        });
        this.$bvToast.toast("Bitte löschen Sie zuerst Ihre bisherige Selektion um neu beginnen zu können.", {
          title: 'Achtung',
          autoHideDelay: 3000,
          appendToast: false,
          toaster: 'b-toaster-top-center',
          variant: 'warning',
          solid: true
        })
      }
    },
    onFeatureCreate({features}) {
      if (!this.currentObject) {
        throw new Error('Can not create a feature without a current object.');
      }
      let coords = features[0].geometry.coordinates;
      this.currentObject.lat = coords[1];
      this.currentObject.lon = coords[0];
    },
    onFeatureDelete() {
      if (!this.currentObject) {
        throw new Error('Can not delete a feature without a current object.');
      }
      this.currentObject.lat = 0.0;
      this.currentObject.lon = 0.0;
    },
    onFeatureMove({features}) {
      if (!this.currentObject) {
        throw new Error('Can not update a feature without a current object.');
      }
      let coords = features[0].geometry.coordinates;
      this.currentObject.lat = coords[1];
      this.currentObject.lon = coords[0];
    },
    removeMapSources() {
      if (this.markers && this.markers.length) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].remove()
        }
      }
      this.markers = [];
      this.removeLayer('maine');
      this.removeLayer('outline');
      this.removeSource('poly');
      this.removeLayer('route');
      this.removeSource('linestring');
      this.removeLayer('point');
      this.removeSource('pointcoord');
      this.removeLayer('selectedPoly');
      this.removeLayer('selectedOutline');
      this.removeSource('selectedPoly');
      this.removeLayer('selectedLine');
      this.removeSource('selectedLine');
      this.removeLayer('selectedPoint');
      this.removeSource('selectedPoint');
    },
    removeLayer(id) {
      if (this.map.getLayer(id)) {
        this.map.removeLayer(id);
      }
    },
    removeSource(id) {
      if (this.map.getSource(id)) {
        this.map.removeSource(id);
      }
    },
    moveDrawLayer() {
      var layers = this.map.getStyle().layers;
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].source && layers[i].source.includes("mapbox-gl-draw")) {
          this.map.moveLayer(layers[i].id);
        }
      }
    },
    onRowSelected(items) {
      console.log("row selected")
      if (this.isOrderMode) {
        return;
      }
      if (this.geocoder !== undefined) {
        this.geocoder.clear();
        this.geocoder.setInput("");
      }
      this.searchQuery = "";
      this.removeMapSources();
      if (items.length === 0) {
        this.currentObject = null;
      } else {
        this.currentObject = items[0];
        this.currentGps = this.coords[items[0].aufisn];
      }
      // add the geometry of the currentGps
      let bounds = this.calculateLayers();
      if (this.currentGps && bounds === null && this.currentGps.strasse_hnr !== "" && this.currentGps.plz !== "") {
        this.searchQuery += this.currentGps.strasse_hnr + ", " + this.currentGps.plz + " " + this.currentGps.ort
      }
      this.addMarkers();
      this.moveDrawLayer();
      bounds = this.addPoint(bounds);
      if (!bounds && this.currentObject) {
        if (this.searchQuery !== "") {
          setTimeout(() => {
            this.geocoder.query(this.searchQuery);
          })
        } else if (this.geoRefPerimeter !== "") {
          setTimeout(() => {
            let sw = this.geoRefPerimeter.split("||")[0].split(",");
            let ne = this.geoRefPerimeter.split("||")[1].split(",");
            this.map.fitBounds([
              [parseFloat(sw[0]), parseFloat(sw[1])], // southwestern corner of the bounds
              [parseFloat(ne[0]), parseFloat(ne[1])] // northeastern corner of the bounds
            ], {padding: 100, duration: 500});

          });
        };
      }
      if (bounds) {
        setTimeout(() => {
          this.map.fitBounds(bounds, {padding: 100, duration: 500});
        });
      }
    },
    calculateLayers() {
        let polyFeatures = [];
      let lineFeatures = [];
      let pointFeatures = [];
      let selectedPoly = null;
      let selectedLine = null;
      let selectedPoint = null;
      let aufisns = [];
      for (let i = 0; i < this.tour_tasks.length; i++) {
        aufisns.push(this.tour_tasks[i].aufisn);
      }
      // make unique
      aufisns = [...new Set(aufisns)];
      let bounds = null;
      for (let i = 0; i < aufisns.length; i++) {
        let cur = this.coords[aufisns[i]];
        if (cur) {
          if (cur.wkt.startsWith("POLYGON")) {
            let poly = cur.wkt;
            if (poly.includes("\\r\\n")) {
              poly = poly.split("\\r\\n")[0];
            }
            poly = poly.replace("POLYGON(", "");
            poly = poly.replace(")", "");
            let splits = poly.split(",");
            let coords = [];
            for (let j = 0; j < splits.length; j++) {
              let item = splits[j].split(" ");
              coords.push([parseFloat(item[1]), parseFloat(item[0])])
            }
            coords.push(coords[0]);
            if (this.currentObject && this.currentObject.aufisn === aufisns[i]) {
              selectedPoly = {
                'type': 'Feature',
                'geometry': {
                  'type': 'Polygon',
                  'coordinates': [
                    coords
                  ]
                }
              };
              bounds = new (mapboxgl.LngLatBounds);
              coords.forEach(el => {
                bounds.extend(el)
              });
            } else {
              polyFeatures.push({
                'type': 'Feature',
                'geometry': {
                  'type': 'Polygon',
                  'coordinates': [
                    coords
                  ]
                }
              });
            }
          } else if (cur.wkt.startsWith("LINESTRING")) {
            let line = cur.wkt;
            if (line.includes("\\r\\n")) {
              line = line.split("\\r\\n")[0];
            }
            line = line.replace("LINESTRING(", "");
            line = line.replace(")", "");
            let splits = line.split(",");
            let coords = [];
            for (let j = 0; j < splits.length; j++) {
              let item = splits[j].split(" ");
              coords.push([parseFloat(item[1]), parseFloat(item[0])])
            }
            if (this.currentObject && this.currentObject.aufisn === aufisns[i]) {
              selectedLine = {
                'type': 'Feature',
                'geometry': {
                  'type': 'LineString',
                  'coordinates': coords
                }
              };
              bounds = new (mapboxgl.LngLatBounds);
              coords.forEach(el => {
                bounds.extend(el)
              });
            } else {
              lineFeatures.push({
                'type': 'Feature',
                'geometry': {
                  'type': 'LineString',
                  'coordinates': coords
                }
              });
            }
          } else if (cur.wkt.startsWith("POINT")) {
            let point = cur.wkt;
            if (point.includes("\\r\\n")) {
              point = point.split("\\r\\n")[0];
            }
            point = point.replace("POINT(", "");
            point = point.replace(")", "");
            let splits = point.split(",");
            let coords = [];
            for (let j = 0; j < splits.length; j++) {
              let item = splits[j].split(" ");
              coords.push([parseFloat(item[1]), parseFloat(item[0])])
            }
            if (this.currentObject && this.currentObject.aufisn === aufisns[i]) {
              selectedPoint = {
                'type': 'Feature',
                'geometry': {
                  'type': 'Point',
                  'coordinates': coords[0]
                }
              };
              bounds = new (mapboxgl.LngLatBounds);
              coords.forEach(el => {
                bounds.extend(el)
              });
            } else {
              pointFeatures.push({
                'type': 'Feature',
                'geometry': {
                  'type': 'Point',
                  'coordinates': coords[0]
                }
              });
            }
          }
        }
      }
      this.map.addSource('poly', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': polyFeatures
        }
      });
      this.map.addLayer({
        'id': 'maine',
        'type': 'fill',
        'source': 'poly', // reference the data source
        'layout': {},
        'paint': {
          'fill-color': '#0080ff', // blue color fill
          'fill-opacity': 0.25
        }
      });
      this.map.addLayer({
        'id': 'outline',
        'type': 'line',
        'source': 'poly',
        'layout': {},
        'paint': {
          'line-color': '#000',
          'line-width': 1
        }
      });
      if (selectedPoly) {
        this.map.addSource('selectedPoly', {
          'type': 'geojson',
          'data': selectedPoly
        });
        this.map.addLayer({
          'id': 'selectedPoly',
          'type': 'fill',
          'source': 'selectedPoly', // reference the data source
          'layout': {},
          'paint': {
            'fill-color': '#016d03', // red color fill
            'fill-opacity': 0.25
          }
        });
        this.map.addLayer({
          'id': 'selectedOutline',
          'type': 'line',
          'source': 'selectedPoly',
          'layout': {},
          'paint': {
            'line-color': '#000',
            'line-width': 1
          }
        });

      }
      this.map.addSource('linestring', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': lineFeatures,
        }
      });
      this.map.addLayer({
        'id': 'route',
        'type': 'line',
        'source': 'linestring',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': 'rgba(0,128,255,0.5)',
          'line-width': 5
        }
      });
      if (selectedLine) {
        this.map.addSource('selectedLine', {
          'type': 'geojson',
          'data': selectedLine
        });
        this.map.addLayer({
          'id': 'selectedLine',
          'type': 'line',
          'source': 'selectedLine',
          'layout': {
            'line-join': 'round',
            'line-cap': 'round'
          },
          'paint': {
            'line-color': 'rgba(1,109,3,0.5)',
            'line-width': 5
          }
        });
      }
      this.map.addSource('pointcoord', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': pointFeatures
        }
      });
      this.map.addLayer({
        'id': 'point',
        'type': 'circle',
        'source': 'pointcoord',
        'paint': {
          'circle-radius': 7,
          'circle-color': 'rgba(0,128,255,0.5)',
          'circle-stroke-width': 1,
          'circle-stroke-color': 'rgba(0,0,0,0.6)',
        },
      });
      if (selectedPoint) {
        this.map.addSource('selectedPoint', {
          'type': 'geojson',
          'data': selectedPoint
        });
        this.map.addLayer({
          'id': 'selectedPoint',
          'type': 'circle',
          'source': 'selectedPoint',
          'paint': {
            'circle-radius': 7,
            'circle-color': 'rgba(1,109,3,0.5)',
            'circle-stroke-width': 1,
            'circle-stroke-color': 'rgba(0,0,0,0.6)',
          },
        });
      }
      return bounds;
    },
    addMarkers() {
      for (let i = 0; i < this.tour_tasks.length; i++) {
          if ((!this.currentObject || this.currentObject.id !== this.tour_tasks[i].id) && this.tour_tasks[i].lat !== 0.0 && this.tour_tasks[i].lon !== 0.0) {
            let el = document.createElement('div');
            el.className = 'm-marker';

            this.markers.push(new mapboxgl.Marker({
              element: el,
              anchor: 'center',
            })
                .setLngLat([this.tour_tasks[i].lon, this.tour_tasks[i].lat])
                .addTo(this.map));
          }
      }
    },
    addPoint(bounds) {
      this.draw.deleteAll();
      this.draw.changeMode("simple_select");
      if (!this.currentObject) {
        return;
      }
      let lat = this.currentObject.lat;
      let lon = this.currentObject.lon;
      if (lat === 0.0 || lon === 0.0) {
        this.draw.changeMode("draw_point");
        return bounds
      }
      let coords = [lon, lat];

      let feature = {
        type: 'Feature',
        properties: {
          id: this.currentObject.id_int ? this.currentObject.id_int : this.currentObject.id
        },
        geometry: {
          type: 'Point',
          coordinates: coords
        }
      };
      this.draw.add(feature);
      bounds = new (mapboxgl.LngLatBounds);
      bounds.extend(coords)
      return bounds;
    },
  }
}
</script>

<style>


.order-marker {width:0; height:0;}

.order-marker  span {
  display:flex;
  justify-content:center;
  align-items:center;
  box-sizing:border-box;
  width: 30px;
  height: 30px;
  color:#fff;
  background: #693;
  border:solid 2px;
  border-radius: 0 70% 70%;
  box-shadow:0 0 2px #000;
  cursor: pointer;
  transform-origin:1 0;
  transform: rotateZ(-135deg);
}

.order-marker b {transform: rotateZ(135deg)}

.start-marker  span {
  display:flex;
  justify-content:center;
  align-items:center;
  box-sizing:border-box;
  width: 30px;
  height: 30px;
  color: #cba1a1;
  background: #ffffff;
  border:solid 2px;
  border-radius: 0 70% 70%;
  box-shadow:0 0 2px #000;
  cursor: pointer;
  transform-origin:1 0;
  transform: rotateZ(-135deg);
}

.start-marker b {transform: rotateZ(135deg)}


.m-marker {
  background-image: url('../../../public/mangel_marker.png');
  background-size: cover;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.sc-message {
  width: 480px;
}

.sc-message--text .sc-message--toolbox {
  display: none;
}

.sc-launcher.opened :before {
  box-shadow: none;
}

.sc-launcher.opened:before {
  box-shadow: none !important;
}

.sc-chat-window {
  border: 1px solid lightgray !important;
  width: 520px !important;
  z-index: 5;
}

.sc-launcher {
  z-index: 5;
}

.sc-header {
  min-height: unset !important;
}

.sc-user-input {
  border-top: 1px solid lightgray !important;

}

.sc-user-input--text {
  width: 450px !important;
}

.sc-header--close-button {
  margin-left: 0 !important;
}

.my-body {
  padding: 0 !important;
}

.hidden_header {
  display: none;
}

.sc-user-input--file-icon-wrapper {
  margin-bottom: 0;
}
</style>

<style scoped>

.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.p-center {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0;
}

.bold-text {
  font-weight: bold;
}

::placeholder { /* Firefox, Chrome, Opera */
  color: black;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}

.icon-muted {
  cursor: initial !important;
  opacity: 0.3 !important;
}

.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
.label-horizontal {
  display: inline-flex;
  align-items: center;
  height: 35px;
}

::v-deep .custom-checkbox {
  min-width: 94px;
}

::v-deep .tab-content {
  border-left: none;
  border-right: none;
  border-bottom: none;
}

::v-deep .flex-body > .card-body {
  display: flex;
}

::v-deep .cursor-pointer > .mapboxgl-canvas-container.mapboxgl-interactive {
  cursor: pointer !important;
}

.grab-handle {
  cursor: move;
  cursor: -webkit-grabbing;
}

.no-margin .card-body {
  padding: 0px !important;
}


.text-black {
  color: black;
}

</style>
